import {HTTP} from './Repository'
export default{
    methods:{
        getFailureResponse(message){
            return {
                'Successful':false,
                'Message':message
            }
        },
        async forgotMyPassword(email){
            if(this.username==""){
                
                return this.getFailureResponse("Please enter your email address and click forgot password")
              }
            let req = {
                email:email,
            }
            try{
                var response = await HTTP.post('walletforgotpass',req)
                if(response.data.Successful==false){return this.getFailureResponse(response.data.RequestException.Message)}
                return  response.data;
            }
            catch(e){
                console.log(e)
                return this.getFailureResponse(e.message)
            }
                
            
        },
        async ChangePassword(email, oldpassword, newpassword,confirmpassword){
            console.log('email ' + email)
            if(newpassword!=confirmpassword){
                return this.getFailureResponse("Your passwords do not match. Please try again.")
            }
            let req = {
                username:email,
                oldpassword:oldpassword,
                newpassword:newpassword,
            }
            try{
                var response = await HTTP.post('changepass',req)
                if(response.data.Successful==false){return this.getFailureResponse(response.data.RequestException.Message)}
                return  response.data;
            }
            catch(e){
                console.log(e)
                return this.getFailureResponse(e.message)
            }
                
            
        },
        async forgotMyPassword(email){
            console.log("email " + email)
            if(this.username==""){
                
                return this.getFailureResponse("Please enter your email address and click forgot password")
              }
            let req = {
                username:email,
            }
            try{
                var response = await HTTP.post('forgotpass',req)
                if(response.data.Successful==false){return this.getFailureResponse(response.data.RequestException.Message)}
                return  response.data;
            }
            catch(e){
                console.log(e)
                return this.getFailureResponse(e.message)
            }
                
            
        },
    },
    
}